<template>
  <div class="team-intr">
    <OrgMap></OrgMap>
    <div style="margin-bottom:0.8rem">
      <el-button @click="addIUser" size="small" type="success" icon="el-icon-plus">添加</el-button>
      <el-button :loading="introLoading" size="small" @click="saveIntro" type="primary">保存</el-button>
    </div>
    <div v-for="(msg,index) in introDate" :key="index" class="introduction-box">
      <div class="team-introduction">
        <span class="trend-title">团队或个人名称</span>
        <el-input maxlength="10" show-word-limit type="text" placeholder="请输入" v-model="msg.name"></el-input>
        <el-button @click="removeIUser(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
      <div class="team-introduction">
        <span class="trend-title">照片</span>
        <div style="display:inline-block;">
          <el-upload 
            class="avatar-uploader"  
            :http-request="(e)=>{uploadfile(e,index)}" 
            action="#" 
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <img v-if="msg.stationImg" :src="msg.stationImg" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="team-introduction">
        <span class="trend-title">团队或个人介绍</span>
        <el-input maxlength="100" show-word-limit :rows="4" type="textarea" placeholder="请输入" v-model="msg.remark"></el-input>
      </div>
    </div>
    <!-- <div class="last-save">
      <el-button :loading="introLoading" size="small" @click="saveIntro" type="primary">保存</el-button>
    </div> -->
  </div>
</template>

<script>
import api from '@/apis/sale/sale'
import upapi from '@/apis/upload'
import OrgMap from './orgMap'
export default {
  components:{
    OrgMap
  },
  data(){
    return{
      introLoading:false,//加载状态
      introDate:[
        {name:'',remark:'',stationImg:''}
      ],
    }
  },
  mounted(){
    this.getIntro()
  },
  methods:{
    //保存数据
    saveIntro(){
      this.introLoading = true;
      api.saveTeam(this.introDate).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.introLoading = false;
        }else{
          this.$message.error(res.message);
          this.introLoading = false;
          return;
        }
      })
    },
    //获取数据
    getIntro(){
      api.getTeam().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.introDate = res.data.list
          }
        }
      })
    },
    //删除一行人员数据
    removeIUser(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delTeam([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getIntro()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.introDate.splice(index,1)
      }
    },
    //图片上传成功的回调函数
    uploadfile(val,i) {
      let fd = new FormData()
      fd.append('file', val.file)
      upapi.upload(fd).then((res) => {
        if (res.code == 10000) {
          this.introDate[i].stationImg = res.data
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //判断上传文件格式是否合法
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //添加一行人员数据
    addIUser(){
      this.introDate.unshift({name:'',remark:'',stationImg:''})
    },
  }
}
</script>
<style lang="less" scoped>
//人员信息 
.team-intr{
  .introduction-box{display:inline-block; border: #3570ff solid 1px; position: relative; width: 30%; padding:1rem; margin-right:1rem; margin-bottom: 1rem; position: relative;
    .team-introduction{ margin-bottom: 15px; display: flex; flex-direction: row;
      .trend-title{ width: 8rem; vertical-align: top; flex-shrink:0;}
      .el-input,.el-textarea{ width: 100%; flex: 1;}
    }
  }
}
</style>
<style lang='less'>
.team-intr{
  .avatar,.avatar-uploader{ width: 6rem; height: 7rem; border: #3570ff solid 1px;}
  .avatar-uploader{ color: #fff; text-align:center; line-height: 6rem; font-size: 2rem;}
}
</style>